import { almacenAxios } from '@/services/Axios';
import { ProductListItem } from '@/models/ProductListItem';

const resource = '/v1/product';

export default {
  async getProductAutocompleteData(query, limit, storeId, clientId) {
    const params = {
      query,
      limit,
      storeId,
      clientId,
    };

    let response = null;
    response = await almacenAxios.get(`${resource}/autocomplete/pos`, { params });
    response = response.data.data;

    return response.map((element) => (
      new ProductListItem(
        element.id,
        element.name,
        element.barcode,
        element.baseCost,
        element.images,
        element.discount_specials,
        element.combo_specials,
        element.model,
        element.brand,
        element.keys,
        element.inventory,
        storeId,
      )
    ));
  },
};
